import React from 'react';
import { COLORS } from '@app/constants';
import { Text, View } from '@/styles/reactnative';
import { useTranslation } from 'react-i18next';
import { useMyProfile } from '../../../../../hooks/user/myprofile';
import styled from 'styled-components';
import { media } from '@/styles/Qtheme.ts';
import { MobileCalVW } from '@utils/CalVW.tsx';

const AccountInfoSecurityProcess = () => {
  const { t } = useTranslation();
  const { data: myinfo } = useMyProfile();

  return (
    <DataWrap>
      <DataLabel>{t('SECURITYLEVEL')}</DataLabel>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Text
          size={16}
          style={{
            fontWeight: '400',
            marginRight: 10,
          }}
        >
          {myinfo?.level === 0
            ? t('Low')
            : myinfo?.level === 1
              ? t('Medium')
              : t('High')}
        </Text>
        {[0, 1, 2].map((item, index) => (
          <View
            key={index.toString()}
            style={{
              height: 5,
              width: 50,
              background:
                parseInt(myinfo?.level) >= item
                  ? item === 0
                    ? COLORS.darkRed
                    : item === 1
                      ? COLORS.lightRed
                      : COLORS.green
                  : COLORS.greyWhite,
              marginRight: 5,
            }}
          />
        ))}
      </View>
    </DataWrap>
  );
};
export default AccountInfoSecurityProcess;

const DataLabel = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16.71px;
  color: ${({ theme }) => theme.inputPlaceholderText};
  margin-bottom: 6px;

  @media ${media.mobile} {
    font-size: ${MobileCalVW(14)};
  }
`;

const DataWrap = styled.div`
  @media ${media.mobile} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
